// export default Notification;
/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import style from "./notifications.module.css";
import commonStyle from "./commonStyles.module.css";
import { useState, useRef, useEffect } from "react";
import { UserNotificationDtails, SetNotiReadStatus, getCandidateLead, getcandidateDetails } from "../apiServices";
import { useDispatch } from "react-redux";
import { commonPopupActions, notiDetailsActions } from "../redux-store/store";
import notificationSound from "../assets/audio/notificationSound.wav";
import { TimeAgo } from "../utility";
import refreshIcon from "../assets/images/refresh-page-option.png";
import CloseIcon from "@mui/icons-material/Close";
import { BsFillBellFill } from "react-icons/bs";
import CustomPagination from "./Custom_ui/CustomPagination";
import { useSelector } from "react-redux";

const Notification = () => {
  const notificationCount = localStorage.getItem("newNotiCount");
  const Dispatch = useDispatch();
  const showNotiRedDot = useSelector(
    (state) => state.notifications.showRedDot // Access the state from redux
  );
  const [openNotification, setOpenNotification] = useState(false);
  const [notificationDetails, setNotificationList] = useState({
    notificationList: [],
    totalPage: 0,
    currentPage: 0,
  });
  const notificationLength = useRef(
    notificationCount != null ? notificationCount : 0
  );
  const [isRotating, setIsRotating] = useState(false);
  // const [showNotiRedDot, setShowNotiRedDot] = useState(false);

  const audio = new Audio(notificationSound);
  const fetchNotifications = (page) => {
    UserNotificationDtails(page).then((data) => {
      notificationLength.current = data.data.totalElements;

      if (localStorage.getItem("newNotiCount") < notificationLength.current) {
        localStorage.setItem("newNotiCount", notificationLength.current);
        // setShowNotiRedDot(true);
        Dispatch(notiDetailsActions.setShowReddot(true));
      }

      localStorage.setItem("newNotiCount", notificationLength.current);

      setNotificationList((prev) => ({
        ...prev,
        notificationList: data.data.content,
        totalPage: data.data.totalPages,
        currentPage: data.data.pageable.pageNumber,
      }));
    });
  };

  // useEffect(() => {
  //   const intervalId = setInterval(() => {
  //     fetchNotifications(notificationDetails.currentPage);
  //   }, 10000);

  //   return () => clearInterval(intervalId);
  // }, [notificationDetails.currentPage]);

  const handleOpen = () => {
    fetchNotifications(0);
    setOpenNotification(!openNotification);
    // setShowNotiRedDot(false);
    Dispatch(notiDetailsActions.setShowReddot(false));
    localStorage.setItem("newNotiCount", notificationLength.current);
  };

  const refreshNotification = () => {
    setIsRotating(true);
    fetchNotifications(0);
    // setShowNotiRedDot(false);
    Dispatch(notiDetailsActions.setShowReddot(false));

    setTimeout(() => {
      setIsRotating(false);
    }, 500);
  };

    const handleCandidateDetails = async (candidateleadId, type) => {
      let data;
      if (type === "CandidateLead") {
        data = await getCandidateLead(candidateleadId);
      } else if (type === "RegisterCandidate") {
        data = await getcandidateDetails(candidateleadId);
      }
  
      // Dispatch action to show the popup and pass the fetched data
      Dispatch(
        commonPopupActions.setShowPopup({
          name: "candidateDetails",
          id: candidateleadId,
          type: type,
          data: data,
        })
      );
    };

  const handleShowNoti = (id) => {
    SetNotiReadStatus(id);
    Dispatch(notiDetailsActions.setNotiDetail(id));
    Dispatch(notiDetailsActions.showDetails(id));
  };

  const changePage = (page) => {
    setNotificationList((prev) => ({
      ...prev,
      currentPage: page,
    }));
    fetchNotifications(page);
  };

  return (
    <>
      <div className="d-inline" style={{ position: "relative" }}>
        <span
          onClick={handleOpen}
          className={`notificationsBtn ${showNotiRedDot ? style.redDot : ""}`}
          id="notificationBell"
        >
          <div
            style={{
              backgroundColor: "#bbb",
              width: "40px",
              height: "40px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "50px",
              border: "none",
              fontSize: "18px",
              cursor: "pointer",
              color: "#fff",
            }}
          >
            <BsFillBellFill />
          </div>
        </span>

        {openNotification && (
          <div className={`${style.notification_container} `}>
            <div className={`${style.noti_list_wrp}`}>
              <div className="d-flex flex-row justify-content-between align-items-center p-1">
                <span className="text-white" style={{ fontSize: "18px" }}>
                  <b>Notifications</b>
                </span>

                <span className={``}>
                  <img
                    onClick={refreshNotification}
                    width="20px"
                    className={`me-4 notificationsRefresh notificationsBtn ${
                      showNotiRedDot ? style.redDot : ""
                    } ${isRotating ? style.rotate : ""}`}
                    src={refreshIcon}
                    alt="Refresh"
                  />
                  <span onClick={handleOpen}>
                    <CloseIcon></CloseIcon>
                  </span>
                </span>
              </div>

              <div
                className={`${commonStyle.scrollbar_primary}  `}
                style={{ maxHeight: "450px" }}
              >
                <div className={`${commonStyle.force_overflow} `}>
                  {notificationDetails.notificationList.length === 0
                    ? "No notifications"
                    : notificationDetails.notificationList.map((el, index) => (
                        <div
                          onClick={() => {
                            handleOpen();
                            handleShowNoti(el.id);
                          }}
                          className={` ${style.notification_item} ${
                            el.notificationRead ? style.readed : ""
                          }`}
                          key={index}
                        >
                          <div
                            className="d-flex justify-content-between align-items-center"
                            // style={{
                            //   marginTop: "-5px",
                            //   marginBottom: "-20px",
                            // }}
                          >
                            <div>
                              <div>
                                {" "}
                                {el.notificationRead && (
                                  <span>
                                    <b
                                      // style={{  }}
                                      className="px-3 rounded-3 text-center"
                                      style={{
                                        fontSize: "12px",
                                        backgroundColor: "#B0F9AA",
                                        color: "#24851C",
                                        textAlign: "center",
                                        border: "1px solid #24851C",
                                      }}
                                    >
                                      Seen
                                    </b>
                                  </span>
                                )}
                                {!el.notificationRead && (
                                  <span className={`${style.newNotiDot}`}>
                                    <b
                                      className="px-3 rounded-3 text-center"
                                      // style={{  }}
                                      style={{
                                        fontSize: "12px",
                                        backgroundColor: "#7AC5DB",
                                        color: "#008DDE",
                                        border: "1px solid #008DDE",
                                      }}
                                    >
                                      New
                                    </b>
                                  </span>
                                )}
                              </div>
                            </div>
                            <div style={{ fontSize: "12px" }}>
                              <TimeAgo dateValue={el.callTime} /> ago
                            </div>
                          </div>
                          <div className="">
                            <span>
                              {" "}
                              Source : <strong>{el.eventType}</strong> !!
                              Contact Number: <strong>{el.mobileNumber}</strong>
                            </span>
                          </div>
                        </div>
                      ))}
                </div>
              </div>
              <div className="bg-light">
                <div className="row">
                  <div className="col-sm-12 d-flex justify-content-end align-items-center mb-2">
                    {/* <Stack spacing={1}> */}
                    <CustomPagination
                      currentPage={notificationDetails.currentPage}
                      totalPages={notificationDetails.totalPage}
                      onPageChange={changePage}
                    />
                    {/* </Stack> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Notification;
